import { useConfiguration } from '@travel-frontend/core';
export const useGetDirectusImageUrl = () => {
  const imageUrl = useConfiguration('directusImageUrl');
  return image => {
    return `${imageUrl}${image}`;
  };
};
export const useDirectusImageUrl = image => {
  const imageUrl = useConfiguration('directusImageUrl');
  return `${imageUrl}${image}`;
};